import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5 2C8.46243 2 6 4.46243 6 7.5C6 10.5376 8.46243 13 11.5 13C14.5376 13 17 10.5376 17 7.5C17 4.46243 14.5376 2 11.5 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 17.75C13 15.1266 15.1266 13 17.75 13C20.3734 13 22.5 15.1266 22.5 17.75C22.5 18.7002 22.221 19.5852 21.7405 20.3276L23.4142 21.999L22.001 23.4142L20.326 21.7415C19.5839 22.2214 18.6995 22.5 17.75 22.5C15.1266 22.5 13 20.3734 13 17.75ZM17.75 15C16.2312 15 15 16.2312 15 17.75C15 19.2688 16.2312 20.5 17.75 20.5C19.2688 20.5 20.5 19.2688 20.5 17.75C20.5 16.2312 19.2688 15 17.75 15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.7495 14C11.9649 15.0446 11.5 16.343 11.5 17.75C11.5 19.3913 12.1326 20.8848 13.1674 22H2V20C2 16.6863 4.68629 14 8 14H12.7495Z"}}]};

const UserSearchFilled = Vue.extend<IconProps>({
  name: 'UserSearchFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'user-search-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UserSearchFilled;
